import { render } from "./specificItemInfo.vue?vue&type=template&id=44c99c92&scoped=true"
import script from "./specificItemInfo.vue?vue&type=script&lang=js"
export * from "./specificItemInfo.vue?vue&type=script&lang=js"

import "./specificItemInfo.vue?vue&type=style&index=0&id=44c99c92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44c99c92"]])

export default __exports__